module.exports = __webpack_public_path__ + "static/hvik_tommi_1-a584aea2ba55b7b0ac589ce4509aff3d.jpg";